import { NextWebVitalsMetric } from 'next/app';

export function reportWebVitals(metric: NextWebVitalsMetric) {
    // Log to console for debugging
    console.log('Web Vitals:', metric);

    // Check if attribution data is available
    if (metric.attribution) {
        console.log('Attribution data:', metric.attribution);

        switch (metric.name) {
            case 'CLS':
                // Find which element caused the layout shift
                if (metric.attribution.largestShiftTarget) {
                    console.log('Largest shift element:', metric.attribution.largestShiftTarget);
                }
                break;

            case 'LCP':
                // Find the LCP element (often an image)
                if (metric.attribution.element) {
                    console.log('LCP element:', metric.attribution.element);
                    const element = metric.attribution.element as HTMLElement;
                    console.log('LCP element tag:', element?.tagName);

                    // If it's an image, log the URL
                    if (element?.tagName === 'IMG') {
                        console.log('LCP image URL:', (element as HTMLImageElement).src);
                    }
                }
                break;

            case 'FID':
            case 'INP':
                // Find which interaction caused the delay
                if (metric.attribution.eventTarget) {
                    console.log('Interaction element:', metric.attribution.eventTarget);
                }
                break;
        }
    }

    // Send to analytics service (optional)
    // sendToAnalytics(metric);
}

// Optional: Send to external analytics
function sendToAnalytics(metric: NextWebVitalsMetric) {
    // Example: Send to Google Analytics
    if (typeof window !== 'undefined' && (window as any).gtag) {
        (window as any).gtag('event', metric.name, {
            custom_parameter_1: metric.value,
            custom_parameter_2: metric.id,
            custom_parameter_3: JSON.stringify(metric.attribution),
        });
    }

    // Example: Send to your own analytics endpoint
    fetch('/api/analytics/web-vitals', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(metric),
    });
} 